import React, { createContext, useContext } from 'react';
export const ConnectorFilePickerContext = createContext(null);
ConnectorFilePickerContext.displayName = 'ConnectorFilePickerContext';
export const useConnectorFilePickerContext = () => {
    const context = useContext(ConnectorFilePickerContext);
    if (!context) {
        throw new Error('useConnectorFilePickerContext must be used within ConnectorFilePickerProvider');
    }
    return context;
};
//# sourceMappingURL=useConnectorFilePickerContext.js.map